import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import cn from 'classnames'
import ButtonPanel from './ButtonPanel'
import {QBM_CRUD, showModal} from '../../modules/modals'
import Loader from '../common/Loader'
import {currentSubjectSelector} from '../../modules/subjects'
import {sourcesGroupSelector, sourcesCursorSelector, setSourcesCursor} from '../../modules/sources'
import {getSortStringCB} from '../../helpers/common'
import {QBM_NAV_SOURCES} from '../../modules/app'
import {toastr} from 'react-redux-toastr'
import { isTeacherOrganisationSelector } from '../../modules/profile'


class Sources extends Component {
    render() {
        const {openItemId, onClick} = this.props
        const isOpen = openItemId === QBM_NAV_SOURCES
        const {formatMessage} = this.context
        return (
            <div className="qbm-accordion-component">
                <div className="qbm-accordion-title"  onClick={onClick}>{formatMessage("Sources")}
                    <div className={cn({"qbm-accordion-arrow":1, open : isOpen})}></div>
                </div>
                <div className={cn({"qbm-accordion-body":1, open : isOpen})}>
                    {
                        this.getBody()
                    }
                </div>
            </div>
        )
    }

    getBody = () => {
        const {currentSubject, loadState : {sourcesLoading}, sourcesCursor, sources} = this.props
        if (!currentSubject.id) return <this.ChooseSubject />
        if (sourcesLoading) return <Loader className="accordion-sidebar-preloader" />
        const Item = this.Item
        Item.displayName = "Item"

        return (
            <React.Fragment>
                <div className="qbm-accordion-content">
                    {
                        !sources.length &&
                        <span className="qbm-accordion-content__item-text qbm-accordion-content__item-text--no-x-borders">{this.context.formatMessage("There is no source for this subject")}</span>
                    }
                    {
                        sources.sort(getSortStringCB('name')).map(({id, name}) => (
                            <Item
                                key = {id}
                                handleClick = {this.handleSourceClick(id)}
                                name = {name}
                                isSelected = {sourcesCursor === id}
                            />
                        ))
                    }
                </div>
                <ButtonPanel
                    handleAddCreateClick = {this.handleActionButtonClick("create")}
                    handleDeleteClick = {this.handleActionButtonClick("delete")}
                    handleUpdateClick = {this.handleActionButtonClick("update")}
                    isUpdateActive = {!!sourcesCursor}
                    isDeleteActive = {!!sourcesCursor}
                />
            </React.Fragment>
        )
    }

    Item = ({name, isSelected, handleClick}) => (
        <div
            onClick={handleClick}
            className={cn("qbm-accordion-content__item", {"qbm-accordion-content__item--selected":isSelected})}
        ><span className="text-ellipsis">{name}</span>
        </div>
    )
    handleSourceClick = (id) => () => {
        const {setSourcesCursor} = this.props
        setSourcesCursor(id)
    }
    handleActionButtonClick = (action) => () => {
        const {showModal, sourcesCursor} = this.props;
        const {isTeacherOrganisation, permission} = this.props;
        const {formatMessage} = this.context;
        if('delete' == action){
            if(isTeacherOrganisation && permission && !permission.allow_delete_question){
                toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
                return ;
            }
        }
        if (!sourcesCursor && ["delete", "update"].includes(action)) return
        showModal({modalType : QBM_CRUD, modalProps : {qbmEntity : "source", qbmCrudAction : action}})
    }
    ChooseSubject = () => (
        <span className="qbm-accordion-content__item-text">{this.context.formatMessage("Choose subject")}</span>
    )

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => {
        const currentSubject = currentSubjectSelector(state) || {}
        const {sourcesLoading, sourcesIds} = currentSubject
        return {
            currentSubject,
            loadState : {sourcesLoading},
            sources : sourcesGroupSelector(state, sourcesIds ? sourcesIds.keySeq().toArray() : []),
            sourcesCursor : sourcesCursorSelector(state),
            permission: state.profile.permission || {},
            isTeacherOrganisation: isTeacherOrganisationSelector(state),
        }
    },
    {setSourcesCursor, showModal}
)(Sources)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/Sources.js